import { privateApi } from "./api.interceptor";

class BoissonService {

  getAll = () => privateApi.get('/boissons');
  delete = (id) => privateApi.delete(`/boissons/${id}`);
  create = (data) => privateApi.post("/boissons", data, {
    headers: {'content-type': 'multipart/form-data'}
  });
  update = (data) => privateApi.put(`/boissons/${data.get('id')}`, data, {
    headers: {'content-type': 'multipart/form-data'}
  });

}

export default new BoissonService();